import React, { useContext, useEffect, useRef, useState } from "react";
import "../../styles/pages/Editor.scss";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import InfoIcon from "../../images/iconinfo.svg";
import PDFImage from "../../images/PDFImage.svg";
import HtmlImage from "../../images/HtmlImage.svg";
import ApproveIcon from "../../images/ApproveIcon.svg";
import VeevaErrorIcon from "../../images/VeevaErrorIcon.svg";
import ClearIcon from "../../images/ClearIcon.svg";
import SaveIcon from "../../images/Save 1.svg";
import PreviewIcon from "../../images/PreviewNew.svg";
import Button from "@mui/material/Button";
import { downLoad } from "./DownloadHTML";
import { scrollbarDownload } from "./ScrollbarDownoadHtml.js";
import { downLoadPdf } from "./PDFDownload";
import exportHTML from "./HtmlExport";
import { saveAssets } from "./saveAssets";
import homebtn from "../../images/Homebtn.svg";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { Slide, toast } from "react-toastify";
import UndoIcon from "../../images/DefaultUndo.svg";
import RedoIcon from "../../images/DefaultRedo.svg";
import UndoIconDisbaled from "../../images/DisabledUndo.svg";
import RedoIconDisabled from "../../images/DisabledRedo.svg";

import {
  sendExport,
  getExport,
  browseImages,
  imagePatch,
  fileSizeValidation,
  veevaIntegration,
  getbannerandTemplateDetails,
  veevaIntegrationHtmlPublish,
  imageConversion,
  imageConversionBaseURL,
  generateRsdScreenshot,
  updateAssetStatus,
  getRSDAssetStatus,
  getSaveAssets,
  saveEmail,
  modifyAsset, preview
} from "../../services/apis";
import Tooltip from "@mui/material/Tooltip";
import ErrComponentToRender from "../../Uitls/apiErrorHandling";
import ExportModal from "../BannerManager/ExportModal.js";
import { CircularProgress } from "@mui/material";
import ValueContext from "../../ContextAPi/appContext";
import FileSaver from "file-saver";

import PreviewModal from "./Preview";
import RVCV from "./RVCV";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { nameValidation } from "../../Uitls/Util.js";
import InfoDetailsDialog from "../BannerManager/InfoDetailsDialog";
import EditorSelect from "../EditorSelect.js";
import BannerEditorConfirmation from "../BannerManager/BannerEditorConfirmation.js";
import RunValidationCheckModal from "./RunValidationCheckModal.js";
import TemplateTypeDropDown from "../TemplateTypeDropDown.js";
import {
  amPmConverter,
  dataURItoBlob,
  generateExpandCloseJS,
  getRandomString,
  renderTheFontLink,
} from "../../Uitls/EditorUtil.js";
import {
  captureHitAreaEditorState,
  ensureHitAreaAnimationEntries,
  mergeHitAreaEditorState,
  stripHitAreasForUndoSnapshot,
} from "../RightPanel/HitAreaModal/utils";

export default function EditorHeader({
  rhsUpdateTrigger,
  setEditComponent,
  setDamsId,
  objPrev,
  layerCompData,
  canvasDimension,
  bgColorCanvas,
  animationObject,
  animationObjRef,
  tempLayer,
  selectedComponent,
  popUpOptions,
  setLayerCompData,
  setSelectedComponent,
  setCount,
  setAnimationObject,
  toggleAnimatedBanner,
  addedActionsList,
  refreshed,
  showAssettype,
  setundoFlag,
  playPause,
  bannerChanged,
  refBannerChanged,
  setBannerChanged,
  showBannertype,
  showBannerName,
  linkedModulesType,
  handleZoomIn,
  handleZoomOut,
  setShowBannerName,
  setMLRstatus,
  selectedSizeOptions,
  selectedBannerSize,
  setMultiSelectedComponent,
  handleChangeSizeRefereshModulesData,
  mustUseData,
  setCanvasDimension,
  setLoadingModules,
  changeInEditor,
  setchangeInEditor,
  setEditModuleClicked,
  moduleSymbol,
  setPlayPause,
  setmoduleSymbol,
  setUndoVersion,
  undoVersion,
  undoStack,
  redoStack,
  bannerValidationCheck,
  saveBannerValidationCheckDetails,
  removeSymbol,
  setRemoveSymbol,
  // Undo Redo Feature Addition
  showPreview,
  setPreView,
  previewURl,
  setpreviewURl,
  previewRedirectHome,
  setPreviewRedirectHome,
  claimReferencesFootnotes,
  setClaimReferencesFoonotes,
  allMustUseDataEmpty,
  setBannerValidationCheck,
  isOneTimeAsset,
  setIsOneTimeAsset,
  getEditSaveAssets,
  loadingModules = false,
}) {
  const { t } = useTranslation();
  const categoriesErr = (value) => {
    toast.error(value, { position: toast.POSITION.TOP_RIGHT });
  };
  const appData = useContext(ValueContext);
  const savedCustomFontList = appData?.savedCustomFontList 
  const { bannerId } = useParams();
  const previewRequestIdRef = useRef(0);
  const [showExport, setExport] = useState(false);
  const [loading, setLoading] = useState(false);
  const [savedObjForPatch, setSavedObjForPatch] = useState({});
  const [checkExportType, setCheckExportType] = useState({
    PDF: false,
    PNG: false,
    JPG: false,
    HTML: false,
    RVCVFILE: false,
  });
  const [rvcvTypes, setRvcvTypes] = React.useState({
    value2X: false,
    value3X: false,
  });
  const [pdfHtmlEnabled, setPdfHtmlEnabled] = useState({
    pdfEnabled: true,
    htmlEnabled: false,
  });
  const [openInfoDetails, setOpenInfoDetails] = useState(false);
  const [bannerTemplateDetails, setBannerTemplateDetails] = useState({});
  const [showConfirmation, setshowConfirmation] = useState(false);
  const [sizeConfirmation, setsizeConfirmation] = useState("");
  const [selectedSizes, setselectedSizes] = useState("");
  const [runValidationCheckEnabled, setRunValidationCheckEnabled] =
    useState(false);
  const [contextMenuGenerateRsd, setContextMenuGenerateRsd] = useState(false);
  const [backupFallback, setBackupFallback] = useState(null);
  const userActionsType = isOneTimeAsset
    ? [
        // {
        //   id: "view-mlr-feedbacks",
        //   label: "View MLR Feedbacks",
        //   value: "View MLR Feedbacks",
        //   disabled: true,
        // },
        { id: "details", label: "Details", value: "Details" },
        { id: "export", label: "Export", value: "Export" },
        {
          id: "backup-image-settings",
          label: "Backup Image Settings",
          value: "Backup Image Settings",
        },
      ]
    : [
        // {
        //   id: "view-mlr-feedbacks",
        //   label: "View MLR Feedbacks",
        //   value: "View MLR Feedbacks",
        //   disabled: true,
        // },
        { id: "details", label: "Details", value: "Details" },
        { id: "export", label: "Export", value: "Export" },
        {
          id: "backup-image-settings",
          label: "Backup Image Settings",
          value: "Backup Image Settings",
        },
      ];
  useEffect(() => {
    if (removeSymbol) {
      localStorage.removeItem("allSymbols");
      patchCall();
      setRemoveSymbol(false);
    }
  }, [removeSymbol]);

  useEffect(() => {
    const backup = appData?.bannersEditCardData?.cards?.backupImages;

    setBackupFallback(backup);
  }, [appData]);
  let animationObjectNew = JSON.parse(JSON.stringify(animationObject || {}));
  const data = [];

  mustUseData.forEach((moduleData) => {
    moduleData.claims.forEach((claim) => {
      if (claim.mlrStatus !== "Expired") {
        if (!claim.isClaimUsed) {
          data.push({
            moduleId: moduleData.moduleDamName,
            elementType: "Claim",
            attribute: "Match Text",
            elementId: claim.claimName,
            content: claim.matchText,
            mlrStatus: claim.mlrStatus,
            mustUse: claim.mustUse,
          });

          if (Array.isArray(claim.matchTextVariants)) {
            claim.matchTextVariants.forEach((variant) => {
              data.push({
                moduleId: moduleData.moduleDamName,
                elementType: "Claim",
                attribute: "Match Text Variant",
                elementId: claim.claimName,
                content: variant.matchText,
                mlrStatus: claim.mlrStatus,
                mustUse: claim.mustUse,
              });
            });
          }

          if (claim.footnotes) {
            const footnotesContent = claim.footnotes.split(/(?<=\.)\s*,\s*/g);
            footnotesContent.forEach((footnote) => {
              data.push({
                moduleId: moduleData.moduleDamName,
                elementType: "Claim",
                attribute: "Footnotes",
                elementId: claim.claimName,
                content: footnote.trim(),
                mlrStatus: claim.mlrStatus,
                mustUse: claim.mustUse,
              });
            });
          }
          if (claim.abbreviation) {
            data.push({
              moduleId: moduleData.moduleDamName,
              elementType: "Claim",
              attribute: "Abbreviation",
              elementId: claim.claimName,
              mlrStatus: claim.mlrStatus,
              mustUse: claim.mustUse,
              content: claim.abbreviation,
            });
          }
          if (Array.isArray(claim.references)) {
            claim.references.forEach((ref) => {
              data.push({
                moduleId: moduleData.moduleDamName,
                elementType: "Claim",
                attribute: "Reference",
                elementId: claim.claimName,
                content: ref.documentName,
                mlrStatus: claim.mlrStatus,
                mustUse: claim.mustUse,
              });
            });
          }
        }

        if (
          Array.isArray(claim.relatedClaims) &&
          claim.relatedClaims.length > 0
        ) {
          claim.relatedClaims.forEach((relatedClaim) => {
            if (relatedClaim.mlrStatus !== "Expired") {
              data.push({
                moduleId: moduleData.moduleDamName,
                elementType: "Related Claim",
                attribute: "Match Text",
                elementId: relatedClaim.claimName,
                content: relatedClaim.matchText,
                mlrStatus: relatedClaim.mlrStatus,
                mustUse: claim.mustUse,
              });

              if (Array.isArray(relatedClaim.matchTextVariants)) {
                relatedClaim.matchTextVariants.forEach((variant) => {
                  data.push({
                    moduleId: moduleData.moduleDamName,
                    elementType: "Related Claim",
                    attribute: "Match Text Variant",
                    elementId: relatedClaim.claimName,
                    content: variant.matchText,
                    mlrStatus: relatedClaim.mlrStatus,
                    mustUse: claim.mustUse,
                  });
                });
              }
              if (relatedClaim.footnotes) {
                const relatedClaimsFootnotesContent =
                  relatedClaim.footnotes.split(/(?<=\.)\s*,\s*/g);
                relatedClaimsFootnotesContent.forEach((footnote) => {
                  data.push({
                    moduleId: moduleData.moduleDamName,
                    elementType: "Related Claim",
                    attribute: "Footnotes",
                    elementId: relatedClaim.claimName,
                    content: footnote.trim(),
                    mlrStatus: relatedClaim.mlrStatus,
                    mustUse: claim.mustUse,
                  });
                });
              }
              if (relatedClaim.abbreviation) {
                data.push({
                  moduleId: moduleData.moduleDamName,
                  elementType: "Related Claim",
                  attribute: "Abbreviation",
                  elementId: relatedClaim.claimName,
                  content: relatedClaim.abbreviation,
                  mlrStatus: relatedClaim.mlrStatus,
                  mustUse: claim.mustUse,
                });
              }
              if (Array.isArray(relatedClaim.references)) {
                relatedClaim.references.forEach((ref) => {
                  data.push({
                    moduleId: moduleData.moduleDamName,
                    elementType: "Related Claim",
                    attribute: "Reference",
                    elementId: relatedClaim.claimName,
                    content: ref.documentName,
                    mlrStatus: relatedClaim.mlrStatus,
                    mustUse: claim.mustUse,
                  });
                });
              }
            }
          });
        }
      }
    });

    moduleData.reusableTexts.forEach((rt) => {
      if (rt.mlrStatus !== "Expired") {
        data.push({
          moduleId: moduleData.moduleDamName,
          elementType: "Reusable Text",
          attribute: "Match Text",
          elementId: rt.reusableTextName,
          content: rt.matchText,
          mlrStatus: rt.mlrStatus,
          mustUse: rt.mustUse,
        });
        rt.matchTextVariants.forEach((mtRt, index) => {
          data.push({
            moduleId: moduleData.moduleDamName,
            elementType: "Reusable Text",
            attribute: "Match Text Variant",
            elementId: rt.reusableTextName,
            content: mtRt.matchText,
            mlrStatus: rt.mlrStatus,
            mustUse: rt.mustUse,
          });
        });
      }
    });

    moduleData.components.forEach((component) => {
      if (component.mlrStatus !== "Expired") {
        if (!component.isComponentUsed) {
          if (component.componentUrl) {
            data.push({
              moduleId: moduleData.moduleDamName,
              elementType: "Component",
              attribute: component.subType,
              elementId: component.componentDocNumber,
              content: component.componentUrl,
              image: true,
              mlrStatus: component.mlrStatus,
              mustUse: component.mustUse,
            });
          }
          if (component.title) {
            data.push({
              moduleId: moduleData.moduleDamName,
              elementType: "Component",
              attribute: "Title",
              elementId: component.componentDocNumber,
              content: component.title,
              mlrStatus: component.mlrStatus,
              mustUse: component.mustUse,
            });
          }
        }

        if (
          Array.isArray(component.relatedClaims) &&
          component.relatedClaims.length > 0
        ) {
          component.relatedClaims.forEach((relatedClaim) => {
            if (relatedClaim.mlrStatus !== "Expired") {
              data.push({
                moduleId: moduleData.moduleDamName,
                elementType: "Related Claim",
                attribute: "Match Text",
                elementId: relatedClaim.claimName,
                content: relatedClaim.matchText,
                mlrStatus: relatedClaim.mlrStatus,
                mustUse: true,
              });

              if (Array.isArray(relatedClaim.matchTextVariants)) {
                relatedClaim.matchTextVariants.forEach((variant) => {
                  data.push({
                    moduleId: moduleData.moduleDamName,
                    elementType: "Related Claim",
                    attribute: "Match Text Variant",
                    elementId: relatedClaim.claimName,
                    content: variant.matchText,
                    mlrStatus: relatedClaim.mlrStatus,
                    mustUse: true,
                  });
                });
              }

              if (relatedClaim.footnotes) {
                const componentRelatedClaimsFootnotesContent =
                  relatedClaim.footnotes.split(/(?<=\.)\s*,\s*/g);
                componentRelatedClaimsFootnotesContent.forEach((footnote) => {
                  data.push({
                    moduleId: moduleData.moduleDamName,
                    elementType: "Related Claim",
                    attribute: "Footnotes",
                    elementId: relatedClaim.claimName,
                    content: footnote.trim(),
                    mlrStatus: relatedClaim.mlrStatus,
                    mustUse: true,
                  });
                });
              }

              if (relatedClaim.abbreviation) {
                data.push({
                  moduleId: moduleData.moduleDamName,
                  elementType: "Related Claim",
                  attribute: "Abbreviation",
                  elementId: relatedClaim.claimName,
                  content: relatedClaim.abbreviation,
                  mlrStatus: relatedClaim.mlrStatus,
                  mustUse: true,
                });
              }

              if (Array.isArray(relatedClaim.references)) {
                relatedClaim.references.forEach((ref) => {
                  data.push({
                    moduleId: moduleData.moduleDamName,
                    elementType: "Related Claim",
                    attribute: "Reference",
                    elementId: relatedClaim.claimName,
                    content: ref.documentName,
                    mlrStatus: relatedClaim.mlrStatus,
                    mustUse: true,
                  });
                });
              }
            }
          });
        }
        if (
          component.relatedReusableTexts &&
          component.relatedReusableTexts.length > 0
        ) {
          component.relatedReusableTexts.forEach((reusableText) => {
            if (reusableText.mlrStatus !== "Expired") {
              data.push({
                moduleId: moduleData.moduleDamName,
                elementType: "Reusable Text",
                attribute: "Match Text",
                elementId: reusableText.reusableTextName,
                content: reusableText.matchText,
                mlrStatus: component.mlrStatus,
                mustUse: true,
              });

              if (Array.isArray(reusableText.matchTextVariants)) {
                reusableText.matchTextVariants.forEach((mtVariant) => {
                  data.push({
                    moduleId: moduleData.moduleDamName,
                    elementType: "Reusable Text",
                    attribute: "Match Text Variant",
                    elementId: reusableText.reusableTextName,
                    content: mtVariant.matchText,
                    mlrStatus: component.mlrStatus,
                    mustUse: true,
                  });
                });
              }
            }
          });
        }
      }
    });
  });

  // Undo/redo history — snapshot based, load-safe baseline seeding.
  const isApplyingHistoryRef = useRef(false);
  const hasSeededBaselineRef = useRef(false);
  const lastAssetIdRef = useRef(null);
  const [someButtonPressed, setsomeButtonPressed] = useState(false);

  const resetUndoRedoHistory = React.useCallback(() => {
    undoStack.current = [];
    redoStack.current = [];
    setUndoVersion(0);
    hasSeededBaselineRef.current = false;
    isApplyingHistoryRef.current = false;
    setsomeButtonPressed(false);
  }, [setUndoVersion, undoStack, redoStack]);

  // Drop any load-time history when the asset changes or hydration starts.
  useEffect(() => {
    const assetId = appData?.assetInfo?.assetId || bannerId;
    if (lastAssetIdRef.current !== assetId) {
      lastAssetIdRef.current = assetId;
      resetUndoRedoHistory();
    }
    if (loadingModules) {
      resetUndoRedoHistory();
    }
  }, [
    appData?.assetInfo?.assetId,
    bannerId,
    loadingModules,
    resetUndoRedoHistory,
  ]);

  // Symbol updates should refresh the latest snapshot in place — not push a new
  // undo step (that used to enable Undo with incomplete stack entries).
  useEffect(() => {
    const handleSymbolChange = () => {
      if (isApplyingHistoryRef.current || someButtonPressed) return;
      const lastElement = undoStack.current[undoStack.current.length - 1];
      if (!lastElement) return;
      lastElement.symbols = localStorage.getItem("allSymbols");
    };

    window.addEventListener("symbolChange", handleSymbolChange);

    return () => {
      window.removeEventListener("symbolChange", handleSymbolChange);
    };
  }, [someButtonPressed, undoStack]);

  // useEffect(() => {
  //   if (!appData.saveCanvasDataOnSessionExpire) return;

  //   handlefunctionality({ target: { name: "save" } }, "change");
  //   appData?.setSaveCanvasDataOnSessionExpire(false);
  // }, [appData.saveCanvasDataOnSessionExpire]);

  const cleanedAnimationObject = React.useMemo(() => {
    const sanitize = (animation) => {
      return animation.map(({ end, hidden, ...rest }) => {
        // Remove 'end' & 'hidden' fields which are only used at runtime
        return { ...rest };
      });
    };

    const result = {};

    for (const key in animationObject) {
      if (Array.isArray(animationObject[key]?.animation)) {
        result[key] = {
          ...animationObject[key],
          animation: sanitize(animationObject[key].animation),
        };
      } else {
        result[key] = animationObject[key];
      }
    }

    return result;
  }, [animationObject]);

  const cleanedLayerCompData = React.useMemo(() => {
    const removeKeys = ({
      multiSelected,
      eachDrag,
      componentStyles,
      ...rest
    }) => {
      const cleanedComponentStyle = componentStyles
        ? Object.fromEntries(
            Object.entries(componentStyles).filter(
              ([key]) =>
                key !== "hMiddle" &&
                key !== "hitAreas" &&
                key !== "hitAreaSequence",
            ),
          )
        : undefined;

      return {
        ...rest,
        ...(cleanedComponentStyle && {
          componentStyles: cleanedComponentStyle,
        }),
        ...(cleanedComponentStyle && {
          componentStyles: cleanedComponentStyle,
        }),
      };
    };

    if (Array.isArray(layerCompData)) {
      return layerCompData.map(removeKeys);
    }

    return removeKeys(layerCompData || {});
  }, [
    layerCompData,
    // track changes in top/left/height/bottom/width of all objects
    JSON.stringify(
      layerCompData?.map((item) => ({
        top: item.componentStyles?.top,
        left: item.componentStyles?.left,
        height: item.componentStyles?.height,
        bottom: item.componentStyles?.bottom,
        width: item.componentStyles?.width,
        layerWidth: item.componentStyles?.layerWidth,
      })),
    ),
  ]);

  useEffect(() => {
    // Never record while the banner/modules are still hydrating.
    if (loadingModules) return;

    const canCaptureSnapshot = isOneTimeAsset || Boolean(moduleSymbol);
    if (!canCaptureSnapshot) return;

    const handler = setTimeout(() => {
      if (isApplyingHistoryRef.current || someButtonPressed) {
        isApplyingHistoryRef.current = false;
        setsomeButtonPressed(false);
        return;
      }
      if (playPause?.complete) {
        setPlayPause((prev) => ({
          ...prev,
          complete: false,
        }));
        return;
      }

      let inputVal =
        canvasDimension?.fps < 35
          ? 35
          : canvasDimension?.fps > 99
            ? 99
            : canvasDimension?.fps;

      const strippedState = stripHitAreasForUndoSnapshot(
        layerCompData,
        animationObject,
      );

      const snapshot = {
        animationObject: JSON.parse(
          JSON.stringify(strippedState.animationObject),
        ),
        layerCompData: JSON.parse(
          JSON.stringify(strippedState.layerCompData),
        ),
        bgColorCanvas: bgColorCanvas,
        fps: inputVal,
        loopAnimation: canvasDimension?.loopAnimation,
        globalLink: canvasDimension?.globalLink,
        symbols: localStorage.getItem("allSymbols"),
        moduleSymbol: JSON.parse(JSON.stringify(moduleSymbol ?? "")),
        claimReferencesFootnotes: JSON.parse(
          JSON.stringify(claimReferencesFootnotes ?? []),
        ),
      };

      const layerCount = Array.isArray(snapshot.layerCompData)
        ? snapshot.layerCompData.length
        : 0;
      const lastSnapshot = undoStack.current[undoStack.current.length - 1];
      const lastLayerCount = Array.isArray(lastSnapshot?.layerCompData)
        ? lastSnapshot.layerCompData.length
        : 0;

      // Never keep an empty canvas snapshot once content exists (load race).
      if (layerCount === 0 && lastLayerCount > 0) {
        return;
      }

      // First content after load: replace any empty/partial entries with one baseline.
      // Undo stays disabled until a second distinct user edit is recorded.
      if (!hasSeededBaselineRef.current) {
        undoStack.current = [snapshot];
        redoStack.current = [];
        hasSeededBaselineRef.current = true;
        setUndoVersion(1);
        return;
      }

      if (layerCount > 0 && lastLayerCount === 0) {
        undoStack.current = [snapshot];
        redoStack.current = [];
        setUndoVersion(1);
        return;
      }

      // Skip duplicate consecutive snapshots.
      try {
        const nextSig = JSON.stringify({
          layerCompData: snapshot.layerCompData,
          animationObject: snapshot.animationObject,
          bgColorCanvas: snapshot.bgColorCanvas,
          fps: snapshot.fps,
          loopAnimation: snapshot.loopAnimation,
          globalLink: snapshot.globalLink,
          claimReferencesFootnotes: snapshot.claimReferencesFootnotes,
        });
        const lastSig = JSON.stringify({
          layerCompData: lastSnapshot?.layerCompData,
          animationObject: lastSnapshot?.animationObject,
          bgColorCanvas: lastSnapshot?.bgColorCanvas,
          fps: lastSnapshot?.fps,
          loopAnimation: lastSnapshot?.loopAnimation,
          globalLink: lastSnapshot?.globalLink,
          claimReferencesFootnotes: lastSnapshot?.claimReferencesFootnotes,
        });
        if (lastSnapshot && nextSig === lastSig) {
          lastSnapshot.symbols = snapshot.symbols;
          lastSnapshot.moduleSymbol = snapshot.moduleSymbol;
          return;
        }
      } catch (error) {
        // fall through and push
      }

      redoStack.current = [];
      undoStack.current.push(snapshot);
      setUndoVersion(undoStack.current.length);

      if (undoStack.current.length > 50) {
        undoStack.current.shift();
        setUndoVersion(undoStack.current.length);
      }
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [
    JSON.stringify(cleanedAnimationObject),
    JSON.stringify(cleanedLayerCompData),
    bgColorCanvas,
    canvasDimension?.loopAnimation,
    canvasDimension?.fps,
    canvasDimension?.globalLink,
    JSON.stringify(moduleSymbol),
    isOneTimeAsset,
    loadingModules,
    JSON.stringify(claimReferencesFootnotes),
    layerCompData,
    animationObject,
    someButtonPressed,
    playPause?.complete,
    setPlayPause,
    setUndoVersion,
    undoStack,
    redoStack,
  ]);

  const handleUndo = () => {
    setsomeButtonPressed(true);
    isApplyingHistoryRef.current = true;
    if (undoStack.current.length > 1) {
      const preservedHitAreaState = captureHitAreaEditorState(
        layerCompData,
        animationObject,
      );
      const current = undoStack.current.pop();
      const previous = undoStack.current[undoStack.current.length - 1];
      const previousLayerCount = Array.isArray(previous?.layerCompData)
        ? previous.layerCompData.length
        : 0;
      const currentLiveCount = Array.isArray(layerCompData)
        ? layerCompData.length
        : 0;

      // Guard: never wipe a loaded canvas by restoring an empty load-time snapshot.
      if (previousLayerCount === 0 && currentLiveCount > 0) {
        undoStack.current.push(current);
        // Drop the bad empty baseline so Undo disables until a real edit exists.
        undoStack.current = undoStack.current.filter(
          (entry) =>
            Array.isArray(entry?.layerCompData) &&
            entry.layerCompData.length > 0,
        );
        if (undoStack.current.length === 0) {
          undoStack.current = [current];
        }
        hasSeededBaselineRef.current = true;
        setUndoVersion(undoStack.current.length);
        isApplyingHistoryRef.current = false;
        setsomeButtonPressed(false);
        return;
      }

      redoStack.current.push(current);
      setUndoVersion(undoStack.current.length);
      if (!previous?.layerCompData) {
        isApplyingHistoryRef.current = false;
        setsomeButtonPressed(false);
        return;
      }
      const mergedState = mergeHitAreaEditorState(
        previous.layerCompData,
        previous.animationObject,
        preservedHitAreaState,
      );
      setAnimationObject(
        JSON.parse(JSON.stringify(mergedState.animationObject)),
      );
      if (previous.symbols !== undefined && previous.symbols !== null) {
        localStorage.setItem("allSymbols", previous.symbols);
      }
      // 🔴 NEW: restore moduleSymbol
      if (previous.moduleSymbol !== undefined) {
        setmoduleSymbol(JSON.parse(JSON.stringify(previous.moduleSymbol)));
      }
      // NEW: restore the footnotes array for this undo state
      if (previous.claimReferencesFootnotes !== undefined) {
        setClaimReferencesFoonotes(
          JSON.parse(JSON.stringify(previous.claimReferencesFootnotes)),
        );
      }
      const newLayerData = JSON.parse(
        JSON.stringify(mergedState.layerCompData),
      );
      setLayerCompData(newLayerData);

      if (selectedComponent?.id) {
        const newSelected = newLayerData.find(
          (item) => item.id === selectedComponent.id,
        );
        if (newSelected) {
          setSelectedComponent(newSelected || {});
          setchangeInEditor(!changeInEditor);
        }
      }
      setCanvasDimension({
        ...canvasDimension,
        backgroundColor: previous.bgColorCanvas,
        fps: previous.fps,
        loopAnimation: previous.loopAnimation,
        globalLink: previous.globalLink,
      });
    } else {
      isApplyingHistoryRef.current = false;
      setsomeButtonPressed(false);
    }
  };

  const handleRedo = () => {
    setsomeButtonPressed(true);
    isApplyingHistoryRef.current = true;
    if (redoStack.current.length > 0) {
      const preservedHitAreaState = captureHitAreaEditorState(
        layerCompData,
        animationObject,
      );
      const next = redoStack.current.pop();
      undoStack.current.push(next);
      setUndoVersion(undoStack.current.length);

      if (!next?.layerCompData) {
        isApplyingHistoryRef.current = false;
        setsomeButtonPressed(false);
        return;
      }

      const mergedState = mergeHitAreaEditorState(
        next.layerCompData,
        next.animationObject,
        preservedHitAreaState,
      );
      const newLayerData = JSON.parse(
        JSON.stringify(mergedState.layerCompData),
      );
      setLayerCompData(newLayerData);

      if (selectedComponent?.id) {
        const newSelected = newLayerData.find(
          (item) => item.id === selectedComponent.id,
        );
        if (newSelected) {
          setSelectedComponent(newSelected || {});
          setchangeInEditor(!changeInEditor);
        }
      }

      setAnimationObject(
        JSON.parse(JSON.stringify(mergedState.animationObject)),
      );

      if (next.symbols !== undefined && next.symbols !== null) {
        localStorage.setItem("allSymbols", next.symbols);
      }
      // 🔴 NEW: restore moduleSymbol
      if (next.moduleSymbol !== undefined) {
        setmoduleSymbol(JSON.parse(JSON.stringify(next.moduleSymbol)));
      }
      // NEW: restore footnotes array for redo state
      if (next.claimReferencesFootnotes !== undefined) {
        setClaimReferencesFoonotes(
          JSON.parse(JSON.stringify(next.claimReferencesFootnotes)),
        );
      }
      setCanvasDimension({
        ...canvasDimension,
        backgroundColor: next.bgColorCanvas,
        fps: next.fps,
        loopAnimation: next.loopAnimation,
        globalLink: next.globalLink,
      });
    } else {
      isApplyingHistoryRef.current = false;
      setsomeButtonPressed(false);
    }
  };

  // Added for handling ctrl and cmd z and y for undo redo
  // useEffect(() => {
  //   const handleKeyDown = (e) => {
  //     const isUndo = (e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "z";
  //     const isRedo =
  //       (e.ctrlKey && e.key.toLowerCase() === "y") ||
  //       (e.metaKey &&
  //         (e.key.toLowerCase() === "y" ||
  //           (e.shiftKey && e.key.toLowerCase() === "z")));
  //     if (isUndo) {
  //       e.preventDefault();
  //       if (undoVersion > 1) handleUndo();
  //     }

  //     if (isRedo) {
  //       e.preventDefault();
  //       if (redoStack.current.length !== 0) handleRedo();
  //     }
  //   };

  //   window.addEventListener("keydown", handleKeyDown);
  //   return () => window.removeEventListener("keydown", handleKeyDown);
  // }, [undoVersion, redoStack, handleUndo, handleRedo]);

  // Undo Redo Feature Addition

  const isValidArray = (arr) =>
    !arr.some((innerArray) => innerArray.length === 0);

  const handleGenerateRSD = async () => {
    await handlefunctionality({ target: { name: "save" } }, "change");
    let arr = await handleCheckAllBanner();
    // if ( isValidArray(arr) || allMustUseDataEmpty.current) {

    exportType("rsd");
    // }
    // else {
    //   let bannerId = localStorage.getItem("damDocNumber") || "";
    //   toast.error(
    //     <div className="notificationText">
    //       {t(
    //         `You need to edit all the banners for Veeva Document Number ${bannerId} before generating the RSD.`,
    //       )}
    //     </div>,
    //   );
    // }
  };

  const handleCheckAllBanner = async () => {
    let allIds;
    try {
      allIds = JSON.parse(localStorage.getItem("allBannersForVeevaId")) || [];
    } catch (error) {
      allIds = [];
    }
    let finalIds =
      allIds?.filter((item) => item.value !== appData?.assetInfo?.assetId) ||
      [];
    let arr = finalIds.map((item) => getEditorData(item.value));

    try {
      let responses = await Promise.all(arr);
      return responses;
    } catch (error) {
      return [[]];
    }
  };

  const getEditorData = async (id) => {
    return new Promise((resolve, reject) => {
      getSaveAssets(id, async (response, err, errorCode) => {
        if (err) {
          reject(err);
        } else {
          try {
            const data = await response.data;
            resolve(data?.assetpages?.[0]?.assetpagecomponent || []);
          } catch (error) {
            reject(error);
          }
        }
      });
    });
  };

  const handleBannerSizeChange = (event) => {
    handlefunctionality({ target: { name: "save" } }, "change");
    const ScrollbarComponent = layerCompData.find(
      (component) => component.componentType === "Scrollbar",
    );
    let scrollbarDomObj;
    let scrollbarDownloadContnent;
    if (ScrollbarComponent) {
      setEditComponent(undefined);
      scrollbarDownloadContnent = scrollbarDownload({
        layerCompData: [ScrollbarComponent],
        canvasDimension: {
          height: ScrollbarComponent?.componentStyles?.scrollbarHeight + 10,
          width: ScrollbarComponent?.componentStyles?.width + 10,
        },
        assetId: appData.assetInfo.assetId,
        animationObject: {},
        flag: true,
        popUpOptions: {},
      });
      scrollbarDomObj = formDOMObj(scrollbarDownloadContnent, undefined, { scrollHtmlForScreenshot: true, animationObjectForSync: {} });
    }
    if (layerCompData.length !== 0) {
      let finalDOMObj = downLoad({
        layerCompData: layerCompData,
        assetId: appData.assetInfo.assetId,
        canvasDimension: canvasDimension,
        bgColorCanvas: bgColorCanvas,
        animationObject: animationObjectNew,
        flag: true,
        popUpOptions: popUpOptions,
        toggleAnimatedBanner: toggleAnimatedBanner,
      });
      let DOMObj = formDOMObj(finalDOMObj, "rvcv");

      let obj = {
        page: DOMObj.html,
        scrollHTML: scrollbarDomObj?.html,
        resolution: 2,
        docNumber: localStorage.getItem("damDocNumber"),
        bannerId: bannerId,
        size: {
          width: canvasDimension.width,
          height: canvasDimension.height,
        },
        currentUserName: localStorage.getItem("currentUserName"),
        emailID: localStorage.getItem("userEmail"),
      };

      generateRsdScreenshot(obj, (response, err, status) => {});
    }

    setshowConfirmation(true);
    setsizeConfirmation(event.target.value);
  };

  const handleCancel = () => {
    setshowConfirmation(false);
    setsizeConfirmation("");
  };

  const handleProceed = () => {
    allMustUseDataEmpty.current = true;
    setEditModuleClicked(false);
    setBannerValidationCheck(false);
    setLoadingModules?.(true);
    setshowConfirmation(false);

    handleChangeSizeRefereshModulesData();
    setLayerCompData([]);
    setSelectedComponent({});
    setCount(0);
    setAnimationObject({});
    setCanvasDimension((prev) => ({
      ...prev,
      width: 0,
      height: 0,
    }));
    setMultiSelectedComponent({
      left: 0,
      top: 0,
      width: 0,
      height: 0,
    });

    setTimeout(() => {
      resetUndoRedoHistory();
      setmoduleSymbol("");

      history.replace(`/banner-editor/${sizeConfirmation}`);
      setselectedSizes(sizeConfirmation);
      setsizeConfirmation("");
    }, 1000);
  };
  async function thumbnail() {
    const formData = new FormData();
    let finalDOMObj = {};
    finalDOMObj = downLoad({
      layerCompData: layerCompData,
      assetId: appData.assetInfo.assetId,
      canvasDimension: canvasDimension,
      bgColorCanvas: bgColorCanvas,
      animationObject: {},
      flag: true,
    });
    // }
    if (finalDOMObj === 0) {
      setLoading(false);
      return;
    }
    let DOMObj = formDOMObj(finalDOMObj);
    imageConversion(
      "png",
      { html: DOMObj.html },
      (response, err, errorCode) => {
        if (err) {
          const errCoponent = ErrComponentToRender(errorCode);
          toast.error(errCoponent);
          return;
        } else {
          if (response?.image) {
            const bannerName = getRandomString(9);
            let rep = dataURItoBlob(response?.image);
            var file = new File([rep], `${bannerName}.png`, {
              type: "image/png",
            });
            formData.append("fileName", file);
            browseImages(formData, (response, err, errorCode) => {
              if (err) {
                const errCoponent = ErrComponentToRender(errorCode);
                toast.error(errCoponent);
              } else {
                if (response.data.discription) {
                  patchCallForThumbNail(response.data.discription);
                }
              }
            });
          } else {
            setLoading(false);
            toast.error(
              <div className="notificationText">
                Failed to download the PNG file
              </div>,
            );
            return;
          }
        }
      },
    );
  }

  const patchCallForThumbNail = (url) => {
    imagePatch(
      appData.assetInfo.assetId,
      {
        thumbNail: url,
      },
      (response, err, errorCode) => {
        if (err) {
          const errCoponent = ErrComponentToRender(errorCode);
        } else {
        }
      },
    );
  };
  let animationFinalObj = [];
  const exportType = async (type, veeva) => {
    const formData = new FormData();
    let finalDOMObj = {};
    let docNum = localStorage.getItem("damDocNumber");
    let response = await getRSDAssetStatus(docNum || "");
    if (response?.data === "INPROGRESS") {
      toast.success(
        <div className="notificationText">
          {t(
            "RSD Generation in progress. You will be notified via email once completed.",
          )}
        </div>,
      );
      return;
    }
    if (layerCompData.length === 0 && type !== "rsd") {
      toast.error(
        <div className="notificationText">
          Please drag and drop something on the canvas.
        </div>,
      );
      setLoading(false);
      return;
    }
    animationFinalObj = [];

    // Commented out: do not add a default keyframe at 0s.
    // Object.values(animationObjectNew).forEach((obj) => {
    //   if (obj?.animation.length > 0 && obj.animation[0].delay !== 0) {
    //     let tempObj = obj.animation[0];
    //     tempObj.delay = 0;
    //     tempObj.duration = tempObj.end;
    //     let firstObject = {
    //       ...tempObj,
    //       rotation: 0,
    //       rotationX: 0,
    //       rotationY: 0,
    //       left: 0,
    //       top: 0,
    //       width: tempObj.width,
    //       height: tempObj.height,
    //       transform: 1,
    //       delay: 0,
    //       duration: 0,
    //       ease: "NONE",
    //       end: 0,
    //       opacity: 1,
    //       translateX: tempObj.translateX,
    //       translateY: tempObj.translateY,
    //       transformOriginX: tempObj.transformOriginX,
    //       transformOriginY: tempObj.transformOriginY,
    //       transformOriginZ: tempObj.transformOriginZ,
    //     };
    //     obj.animation.splice(0, 0, firstObject);
    //     obj.animation[1] = tempObj;
    //   }
    // });

    Object.keys(animationObjectNew).forEach((obj) => {
      animationObjectNew[obj].animation.forEach((eachAnimation) => {
        const animationData = {
          api: "to",
          atoms: [obj],
          duration: eachAnimation.duration,
          op: {
            delay: eachAnimation.delay,
            opacity: eachAnimation.opacity,
            ease: eachAnimation.ease,
            rotation: eachAnimation.rotation,
            rotationX: eachAnimation.rotationX,
            rotationY: eachAnimation.rotationY,
            scale: eachAnimation.transform,
            left: 0,
            top: 0,
            transform: `translate(${(eachAnimation.x || 0) + (eachAnimation.translateX || 0)}px,${(eachAnimation.y || 0) + (eachAnimation.translateY || 0)}px)`,
            width: eachAnimation.width,
            height: eachAnimation.height,
            transformOrigin: `${eachAnimation.transformOriginX}% ${eachAnimation.transformOriginY}% ${eachAnimation.transformOriginZ}px`,
            backgroundSize: `${eachAnimation.width}px ${eachAnimation.height}px`,
          },
        };
        animationFinalObj.push(animationData);
      });
    });
    if (type === "rsd") {
      setLoading(false);
      const ScrollbarComponent = layerCompData.find(
        (component) => component.componentType === "Scrollbar",
      );
      let scrollbarDomObj;
      let scrollbarDownloadContnent;
      if (ScrollbarComponent) {
        scrollbarDownloadContnent = scrollbarDownload({
          layerCompData: [ScrollbarComponent],
          canvasDimension: {
            height: ScrollbarComponent?.componentStyles?.scrollbarHeight + 10,
            width: ScrollbarComponent?.componentStyles?.width + 10,
          },
          assetId: appData.assetInfo.assetId,
          animationObject: {},
          flag: true,
          popUpOptions: {},
        });
        scrollbarDomObj = formDOMObj(scrollbarDownloadContnent, undefined, { scrollHtmlForScreenshot: true, animationObjectForSync: {} });
      }
      finalDOMObj = downLoad({
        layerCompData: layerCompData,
        assetId: appData.assetInfo.assetId,
        canvasDimension: canvasDimension,
        bgColorCanvas: bgColorCanvas,
        animationObject: animationObjectNew,
        flag: true,
        popUpOptions: popUpOptions,
        toggleAnimatedBanner: toggleAnimatedBanner,
      });
      let DOMObj = formDOMObj(finalDOMObj, "rvcv");

      let obj = {
        page: DOMObj.html,
        scrollHTML: scrollbarDomObj?.html,
        resolution: 2,
        docNumber: localStorage.getItem("damDocNumber"),
        bannerId: bannerId,
        fromGenerate: true,
        mlrStatus: localStorage.getItem("mlrStatus") || "Not Submitted",
        size: {
          width: canvasDimension.width,
          height: canvasDimension.height,
        },
        currentUserName: localStorage.getItem("currentUserName"),
        emailID: localStorage.getItem("userEmail"),
      };
      setLoading(true);
      updateAssetStatus(obj.docNumber, { status: "INPROGRESS" });
      generateRsdScreenshot(obj, (response, err, status) => {
        if (response) {
          toast.success(
            <div className="notificationText">
              {t(
                "RSD Generation in progress. You will be notified via email once completed.",
              )}
            </div>,
          );
          localStorage.setItem(
            `preferredRsdSize_${localStorage.getItem("damDocNumber")}`,
            `${canvasDimension.width} × ${canvasDimension.height}`,
          );
          setLoading(false);
          history.push("/");
        } else {
          console.error(
            "Error in generateRsdScreenshot:",
            err,
            "Status:",
            status,
          );
          setLoading(false);

          // Show appropriate error messages based on status code
          if (status === 400) {
            toast.error(
              "Invalid request. Please check your inputs and try again.",
            );
          } else if (status === 401) {
            toast.error("Unauthorized! Please log in again.");
          } else if (status === 403) {
            toast.error("You do not have permission to perform this action.");
          } else if (status === 500) {
            toast.error("Server error! Please try again later.");
          } else {
            toast.error("Failed to generate RSD. Please try again.");
          }
        }
      });

      return;
    }
    if (checkExportType.RVCVFILE === true) {
      setLoading(false);
      finalDOMObj = downLoad({
        layerCompData: layerCompData,
        assetId: appData.assetInfo.assetId,
        canvasDimension: canvasDimension,
        bgColorCanvas: bgColorCanvas,
        animationObject: animationObjectNew,
        flag: true,
        popUpOptions: popUpOptions,
        toggleAnimatedBanner: toggleAnimatedBanner,
      });
      let DOMObj = formDOMObj(finalDOMObj, "rvcv");

      let obj = {
        page: DOMObj.html,
        rvcv:
          rvcvTypes.value2X === true ? 2 : rvcvTypes.value3X === true ? 3 : 1,
        name: appData.assetInfo.assetName,
        emailID: localStorage.getItem("userEmail"),
        currentUserName: localStorage.getItem("currentUserName"),
      };
      setLoading(true);
      imageConversionBaseURL("RVCV", obj, (response, err, errorCode) => {
        if (err) {
          // setLoading(false);
          // const errCoponent = ErrComponentToRender(errorCode);
          // toast.error(errCoponent);
          toast.error(
            <div className="notificationText">
              Failed to download the RV/CV file
            </div>,
          );
          setLoading(false);
          return;
        } else {
          if (response.status === 200) {
            setLoading(false);
            toast.success(
              <div className="notificationText">
                Please click on the link sent to you via email to download the
                RV/CV images.
              </div>,
            );
          } else {
            const errCoponent = ErrComponentToRender(response.status);
            toast.error(errCoponent);
            setLoading(false);
          }
        }
      });
    }

    if (finalDOMObj === 0) {
      setLoading(false);
      return;
    }

    Object.keys(checkExportType).forEach(async (key) => {
      if (key === "HTML" && checkExportType[key] === true) {
        let finalDOMObj = downLoad({
          exportData: true,
          layerCompData: layerCompData,
          assetId: appData.assetInfo.assetId,
          canvasDimension: canvasDimension,
          bgColorCanvas: bgColorCanvas,
          animationObject: checkExportType.PDF ? {} : animationObjectNew,
          flag:
            checkExportType.PNG === true || checkExportType.JPEG === true
              ? true
              : false,
          popUpOptions: popUpOptions,
          toggleAnimatedBanner: toggleAnimatedBanner,
        });

        let DOMObjHTML = formDOMObj(finalDOMObj, undefined, {
          backupFallback,
        });
        // getExport(
        //   randomNumber,
        //   encodeURIComponent(appData.assetInfo.assetName),
        //   (response, err, errorCode) => {
        //     if (err) {
        //       const errCoponent = ErrComponentToRender(errorCode);
        //     }
        //   },
        // );
        DOMObjHTML.assetId = appData.assetInfo.assetId
        htmlDownload(DOMObjHTML, backupFallback);
      } else if (key === "JPG" && checkExportType[key] === true) {
        finalDOMObj = downLoad({
          layerCompData: layerCompData,
          assetId: appData.assetInfo.assetId,
          canvasDimension: canvasDimension,
          bgColorCanvas: bgColorCanvas,
          animationObject: checkExportType.PDF ? {} : animationObjectNew,
          flag:
            checkExportType.PNG === true || checkExportType.JPG === true
              ? true
              : false,
          popUpOptions: popUpOptions,
          toggleAnimatedBanner: toggleAnimatedBanner,
        });
        let DOMObj = formDOMObj(finalDOMObj);
        imageConversion(
          "jpeg",
          { html: DOMObj.html },
          (response, err, errorCode) => {
            if (err) {
              toast.error(
                <div className="notificationText">
                  Failed to download the JPEG file
                </div>,
              );
              setLoading(false);
            } else {
              if (response?.image) {
                let rep = dataURItoBlob(response?.image);
                var file = new File(
                  [rep],
                  `${appData.assetInfo.assetName.trim()}.jpg`,
                  { type: "image/jpg" },
                );
                const formDatatype = new FormData();
                formDatatype.append("fileName", file);
                pngJpegPdfDownload(key, formDatatype);
                toast.success(
                  <div className="notificationText">
                    Successfully downloaded the JPEG file
                  </div>,
                );
              } else {
                setLoading(false);
                toast.error(
                  <div className="notificationText">
                    Failed to download the JPEG file
                  </div>,
                );
                return;
              }
            }
          },
        );
      } else if (key === "PNG" && checkExportType[key] === true) {
        finalDOMObj = downLoad({
          layerCompData: layerCompData,
          assetId: appData.assetInfo.assetId,
          canvasDimension: canvasDimension,
          bgColorCanvas: bgColorCanvas,
          animationObject: checkExportType.PDF ? {} : animationObjectNew,
          flag:
            checkExportType.PNG === true || checkExportType.JPG === true
              ? true
              : false,
          popUpOptions: popUpOptions,
          toggleAnimatedBanner: toggleAnimatedBanner,
        });

        let DOMObj = formDOMObj(finalDOMObj);

        imageConversion(
          "png",
          { html: DOMObj.html },
          (response, err, errorCode) => {
            if (err) {
              toast.error(
                <div className="notificationText">
                  Failed to download the PNG file
                </div>,
              );
              setLoading(false);
            } else {
              if (response?.image) {
                let rep = dataURItoBlob(response?.image);

                var file = new File(
                  [rep],
                  `${appData.assetInfo.assetName.trim()}.png`,
                  { type: "image/png" },
                );
                const formDatatype = new FormData();
                formDatatype.append("fileName", file);
                pngJpegPdfDownload(key, formDatatype);
                toast.success(
                  <div className="notificationText">
                    Successfully downloaded the PNG file
                  </div>,
                );
              } else {
                setLoading(false);
                toast.error(
                  <div className="notificationText">
                    Failed to download the PNG file
                  </div>,
                );
                return;
              }
            }
          },
        );
      } else if (key === "PDF" && checkExportType[key] === true) {
        let finalPdf = downLoadPdf(
          layerCompData,
          appData.assetInfo.assetId,
          canvasDimension,
          bgColorCanvas,
          {},
        );
        const formDatatype = new FormData();
        let DOMObj = formDOMObj(finalPdf);

        imageConversionBaseURL(
          "pdf",
          { html: DOMObj.html },
          (response, err, errorCode) => {
            if (err) {
              toast.error(
                <div className="notificationText">
                  Failed to download the PDF file
                </div>,
              );
              setLoading(false);
            } else {
              if (response?.status === 200) {
                var blob = new Blob([response?.data], {
                  type: "application/pdf",
                });
                var file = new File(
                  [blob],
                  `${appData.assetInfo.assetName}.pdf`,
                  {
                    type: "application/pdf",
                  },
                );
                if (veeva === "veeva") {
                  formDatatype.append("pdfFile", file);
                  formDatatype.append("fileName", appData.assetInfo.assetName);
                  return formDatatype;
                }
                formDatatype.append("fileName", file);

                pngJpegPdfDownload(key, formDatatype);
                toast.success(
                  <div className="notificationText">
                    Successfully downloaded the PDF file
                  </div>,
                );
              } else {
                setLoading(false);
                toast.error(
                  <div className="notificationText">
                    Failed to download the PDF file
                  </div>,
                );
                return;
              }
            }
          },
        );
      }
    });

    setCheckExportType({
      ...checkExportType,
      PDF: false,
      HTML: false,
      PNG: false,
      JPG: false,
      RVCVFILE: false,
    });
    setRvcvTypes({
      ...rvcvTypes,
      value2X: false,
      value3X: false,
    });
  };

  const pngJpegPdfDownload = (type, formData) => {
    browseImages(formData, (response, err, errorCode) => {
      if (err) {
        ErrComponentToRender(errorCode);
        setLoading(false);
      } else {
        if (response.data.discription) {
          if (type !== "PDF") patchCallForThumbNail(response.data.discription);

          FileSaver.saveAs(
            response.data.discription,
            `${appData.assetInfo.assetName}.${type}`,
          );
          setLoading(false);
        }
      }
    });
  };
  function htmlDownload(DOMObj) {
    const exportPayload = { ...DOMObj };
    sendExport(exportPayload, (response, err, errorCode) => {
      if (err) {
        const errCoponent = ErrComponentToRender(errorCode);

        toast.error(errCoponent);
      } else {
        getExport(
          randomNumber,
          encodeURIComponent(appData.assetInfo.assetName),
          (response, err, errorCode) => {
            if (err) {
              const errCoponent = ErrComponentToRender(errorCode);
              toast.error(
                <div className="notificationText">
                  {t("Failed to download the HTML package")}
                </div>,
              );
            } else {
              const downloadUrl = window.URL.createObjectURL(
                new Blob([response.data]),
              );
              const link = document.createElement("a");

              link.href = downloadUrl;

              link.setAttribute(
                "download",
                appData.assetInfo.assetName + "HTML.zip",
              );

              document.body.appendChild(link);

              link.click();

              link.remove();
              toast.success(
                <div className="notificationText">
                  {t("Successfully downloaded the HTML package")}
                </div>,
              );
            }
          },
        );
      }
    });

    setLoading(false);
  }
  const patchCall = (bannerSize, origin) => {
    const storedSymbols = localStorage.getItem("allSymbols") || "[]";
    let obj = {};
    if (appData?.genericInfo?.rightUpdaedName === true)
      obj.assetName = appData.assetInfo.assetName.trim();
    obj.campaignId = appData.campaignId;
    obj.brandId = appData.brandId;
    obj.campaign = appData?.genericInfo?.campaign;
    obj.marketName = appData?.genericInfo?.market;
    obj.marketCode = appData.marketCode;
    obj.height = canvasDimension.height;
    obj.width = canvasDimension.width;

    obj.attributes = {
      moduleSymbols: storedSymbols,
      customTemp: appData?.customTempSize,
      backgroundColor: bgColorCanvas,
      fps: canvasDimension.fps,
      globalLink: canvasDimension.globalLink,
      checkGloballink: canvasDimension.checkGloballink,
      checkLoops: canvasDimension.checkLoops,
      loopAnimation: canvasDimension.loopAnimation,
      bannerSize: bannerSize || canvasDimension.bannerSize,
      canvasScale: appData?.genericInfo?.canvasScale,
      draggerWidth: appData?.genericInfo?.draggerWidth,
      custom: canvasDimension.custom,
      searchExpression: appData?.genericInfo?.linkedData?.currentLink
        ? appData?.genericInfo?.searchedFields
        : appData?.genericInfo?.searchFieldsTobeSaved,
      linkedModules: { linkedModules: linkedModulesType },
    };
    var tempObj =
      Object.keys(savedObjForPatch).length === 0 ? objPrev : savedObjForPatch;
    var infoPatchedObj = { ...obj };
    for (let x in tempObj) {
      if (tempObj[x] === obj[x]) {
        delete obj[x];
      }
    }

    if (Object.keys(obj).length !== 0) {
      let DOMObj = handlePreview("save");
      return new Promise((resolve) => {
        modifyAsset(
          appData.assetInfo.assetId,
          { ...obj, editorData: DOMObj },
          (response, err, errorCode) => {
            if (err) {
              const errCoponent = ErrComponentToRender(errorCode);
              if (
                err.response?.data?.errorCode === "ERR_CS_ASSETNAME_EXISTS" &&
                origin !== "backIcon" &&
                origin !== "save"
              ) {
                toast.error(
                  <div className="notificationText">
                    {t("apiErrors.errSaveBannerExist")}
                  </div>,
                );
              } else {
                if (origin !== "backIcon" && origin !== "save")
                  categoriesErr(errCoponent);
              }
              resolve("false");
            } else {
              setSavedObjForPatch(infoPatchedObj);

              resolve("true");
              appData.updateGenericInfo({
                ...appData?.genericInfo,
                rightUpdaed: false,
                rightUpdaedName: false,
              });
            }
          },
        );
      });
    } else
      appData.updateGenericInfo({
        ...appData?.genericInfo,
        rightUpdaed: false,
        rightUpdaedName: false,
      }); //  }
  };

  var stringToHTML = function (str) {
    var dom = document.createElement("div");
    dom.innerHTML = str;
    return dom;
  };
  // const renderAppliedFonts = (response, fromExport) => {
  //   const myFontSpanTags = [];
  //   let fontsLink = "";

  //   response.forEach((layer) => {
  //     if (layer.componentType === "Button" || layer.componentType === "Text") {
  //       fontsLink = renderTheFontLink(layer.componentStyles.fontFamily);
  //       myFontSpanTags.push(stringToHTML(layer.froalaText));
  //     }
  //   });

  //   if (myFontSpanTags.length < 1) return;
  //   myFontSpanTags.forEach((myFontSpanTag) => {
  //     let compFamiliesLength =
  //       myFontSpanTag.getElementsByTagName("span").length;
  //     let params = [];
  //     for (let i = 0; i < compFamiliesLength; i++) {
  //       params[i] = myFontSpanTag
  //         .getElementsByTagName("span")
  //         [i].style.cssText.replaceAll(";", ",");
  //     }
  //     let compFamilies = params.map((param) => {
  //       let jsonStrig = "[{";
  //       let items = param.split(",");
  //       for (let i = 0; i < items.length; i++) {
  //         items[i] = items[i].includes("font-family")
  //           ? items[i].replace(/["/]+/g, "")
  //           : items[i];
  //         if (items[i].startsWith(" ")) items[i] = items[i].substring(1);
  //         let current = items[i].split(":");

  //         jsonStrig += '"' + current[0] + '":"' + current[1] + '",';
  //       }

  //       jsonStrig = jsonStrig.substr(0, jsonStrig.length - 1);

  //       jsonStrig += "}]";
  //       return JSON.parse(jsonStrig)[0];
  //     });
  //     compFamilies.forEach((family) => {
  //       if (family.hasOwnProperty("font-family")) {
  //         let fontFamily = family["font-family"];
  //         if (fontFamily.startsWith(" ")) fontFamily = fontFamily.substring(1);
  //         let tempFont = fontFamily?.split(" ").join("+");
  //         let position = fontsLink.lastIndexOf("&");
  //         fontsLink = [
  //           "Arial",
  //           "Georgia",
  //           "Tahoma",
  //           "Times New Roman",
  //           "Verdana",
  //         ].includes(tempFont)
  //           ? fontsLink
  //           : [
  //               fontsLink.slice(0, position + 1),
  //               `family=${tempFont}:wght@100;200;300;400;500;600;700;800;900&`,
  //               fontsLink.slice(position),
  //             ].join("");
  //       }
  //     });
  //   });
  //   return fontsLink;
  // };

  const renderAppliedFonts = (layers) => {
    if (!Array.isArray(layers) || layers.length === 0) return "";

    const customFonts = appData?.savedCustomFontList
    const customFontNames = customFonts.map((font) => font.familyName)

    const SYSTEM_FONTS = new Set(
      ["Arial", "Georgia", "Tahoma", "Times New Roman", "Verdana"].map((f) =>
        f.toLowerCase(),
      ),
    );

    const normalizeFont = (f) => {
      if (customFontNames.includes(f)) return null
      if (!f) return null;
      let first = String(f).split(",")[0].trim(); // take first before fallback list
      first = first.replace(/^["']|["']$/g, ""); // remove quotes
      if (!first) return null;
      if (SYSTEM_FONTS.has(first.toLowerCase())) return null;
      return first;
    };

    const fonts = new Set();

    // 1) from componentStyles.fontFamily (Text/Button)
    layers.forEach((layer) => {
      if (
        layer?.componentType === "Button" ||
        layer?.componentType === "Text"
      ) {
        const ff = normalizeFont(layer?.componentStyles?.fontFamily);
        if (ff) fonts.add(ff);
      }
    });

    // 2) from Froala spans (if any)
    layers.forEach((layer) => {
      if (!layer?.froalaText) return;
      const dom = document.createElement("div");
      dom.innerHTML = layer.froalaText;

      const spans = dom.getElementsByTagName("span");
      for (let i = 0; i < spans.length; i++) {
        const ff = normalizeFont(spans[i]?.style?.fontFamily);
        if (ff) fonts.add(ff);
      }
    });

    if (fonts.size === 0) return "";

    // return multiple link tags (simple + reliable)
    return Array.from(fonts)
      .map((font) => renderTheFontLink(font))
      .join("\n");
  };

  async function handlefunctionality(e, origin) {
    const validationObj = [
      { assetId: appData.assetInfo.assetId, isValid: data.length === 0 },
    ];
    saveBannerValidationCheckDetails(validationObj);

    if (origin !== "change") {
      e.preventDefault();
    }
    if (!nameValidation(appData.assetInfo.assetName, showAssettype)) {
      return;
    }

    const { name } = e.target;
    if (name === "save" && !origin) {
      const email = window.localStorage.getItem("userEmail");
      const assetId = appData?.assetInfo?.assetId;

      if (email && assetId) {
        const payload = {
          assetId,
          email,
          update: true,
        };
        saveEmail(payload, (response, err, errorCode) => {
          if (err) {
            console.error("Failed to save user email:", err);
          }
        });
      }
    }
    let DOMObj = handlePreview("save");
    fileSizeValidation(DOMObj, async (response, err, errorCode) => {
      if (err) {
        patchCall(200, origin);
        // if (origin !== "backIcon") {
        //   toast.error(
        //     <div className="notificationText">
        //       {t("Warning - Banner size exceeds 200 KB!")}
        //     </div>,
        //   );
        // }
      } else {
        patchCall(0, origin);
      }
      if (name === "save" || origin === "backIcon") {
        if (origin === "backIcon") {
          appData.setActiveCards([]);
        }
        if (
          selectedComponent?.componentStyles?.layerName !== "" ||
          selectedComponent?.componentStyles?.layerName?.length !== 0
        ) {
          let result = "save";
          if (
            appData?.genericInfo?.rightUpdaed === true ||
            appData?.genericInfo?.rightUpdaedName === true
          ) {
            result = await patchCall("", "save");
          }
          if (result === "save" || result === "true") {
            const ScrollbarComponent = layerCompData.find(
              (component) => component.componentType === "Scrollbar",
            );
            let scrollbarDomObj;
            let scrollbarDownloadContnent;
            if (ScrollbarComponent) {
              scrollbarDownloadContnent = scrollbarDownload({
                layerCompData: [ScrollbarComponent],
                canvasDimension: {
                  height:
                    ScrollbarComponent?.componentStyles?.scrollbarHeight + 10,
                  width: ScrollbarComponent?.componentStyles?.width + 10,
                },
                assetId: appData.assetInfo.assetId,
                animationObject: {},
                flag: true,
                popUpOptions: {},
              });
              scrollbarDomObj = formDOMObj(scrollbarDownloadContnent, undefined, { scrollHtmlForScreenshot: true, animationObjectForSync: {} });
            }
            if (layerCompData.length !== 0) {
              let finalDOMObj = downLoad({
                layerCompData: layerCompData,
                assetId: appData.assetInfo.assetId,
                canvasDimension: canvasDimension,
                bgColorCanvas: bgColorCanvas,
                animationObject: animationObjectNew,
                flag: true,
                popUpOptions: popUpOptions,
                toggleAnimatedBanner: toggleAnimatedBanner,
              });
              let DOMObj = formDOMObj(finalDOMObj, "rvcv");

              let obj = {
                page: DOMObj.html,
                scrollHTML: scrollbarDomObj?.html,
                resolution: 2,
                docNumber: localStorage.getItem("damDocNumber"),
                bannerId: bannerId,
                size: {
                  width: canvasDimension.width,
                  height: canvasDimension.height,
                },
                currentUserName: localStorage.getItem("currentUserName"),
                emailID: localStorage.getItem("userEmail"),
              };

              generateRsdScreenshot(obj, (response, err, status) => {});
            }
            saveAssets({
              layerCompData,
              assetId: appData.assetInfo.assetId,
              animationObject,
              setLayerCompData,
              setundoFlag,
              bannerChanged,
              refBannerChanged,
              setBannerChanged,
              origin,
              bannerName: appData.assetInfo.assetName,
              setShowBannerName,
            });
            thumbnail();
          }
        }
      } else if (name === "export") {
        setLoading(true);

        setExport(true);
        setCheckExportType({
          ...checkExportType,
          PDF: false,
          HTML: false,
          PNG: false,
          JPG: false,
          RVCVFILE: false,
        });
        setRvcvTypes({
          ...rvcvTypes,
          value2X: false,
          value3X: false,
        });
      }
    });
  }
  let randomNumber = new Date().getTime();
  function formDOMObj(finalDOMObj, rvcv, exportOptions = {}) {
    let animationFinalObjToString = JSON.stringify(exportOptions?.scrollHtmlForScreenshot ? [] : animationFinalObj);
    let completeObj = JSON.stringify(finalDOMObj.trackHeight);
    // Prefer the normalized clone used to build animationFinalObj so preview
    // sync helpers match the timeline that was just generated.
    let animationObjecStringified = JSON.stringify(
      exportOptions.animationObjectForSync || animationObject || {}
    );
    let layerLink = "";
    let downloadType = checkExportType.PDF;
    let hrefUrl =
      canvasDimension.checkGloballink === true &&
      canvasDimension.checkGloballink !== undefined
        ? canvasDimension.globalLink
        : "javascript:void(0)";

    // let typeDiff =
    //   downloadType === true
    //     ? `<a
    //     id="canvas-page"
    //     href= '${hrefUrl}'
    //   >
    //   ${finalDOMObj.DomObj}
    //   </a>`
    //     : `<div
    //       id="canvas-page"
    //       data-global="${canvasDimension.globalLink}"
    //       data-link="${canvasDimension.checkGloballink}"
    //       onClick="enableTxt(this)"
    //     >
    //       ${finalDOMObj.DomObj}
    //     </div>`;

    let typeDiff = `
  <div
    id="canvas-page"
  >
    ${finalDOMObj.DomObj}
  </div>
`;
    let expandClose = generateExpandCloseJS(canvasDimension);
    layerLink = renderAppliedFonts(layerCompData, true) || "";
    const savedCustomFontList = appData?.savedCustomFontList || []

    let DOMObj = {
      html:
        rvcv === "rvcv"
          ? RVCV({
              canvasDimension,
              finalDOMObj,
              animationFinalObjToString,
              layerLink,
              completeObj,
              typeDiff,
              layerCompData,
              savedCustomFontList,
              backupFallback,
            })
          : exportHTML({
              savedCustomFontList,
              canvasDimension,
              finalDOMObj,
              animationFinalObjToString,
              layerLink,
              completeObj,
              typeDiff,
              expandClose,
              animationObjecStringified,
              backupFallback,
              bannerName: appData.assetInfo.assetName?.trim(),
            }),

      cssObj: {
        fileName: "Styles",
        content: "",
      },
      js: "",
      atomId: finalDOMObj.atomId,
      atomUrl: finalDOMObj.atomUrl,
      img: finalDOMObj.img,
      backupImage: backupFallback?.s3Url
        ? {
            url: backupFallback.s3Url,
          }
        : undefined,
      id: randomNumber,
      fileName: appData.assetInfo.assetName.trim(),
    };
    return DOMObj;
  }
  function handlePreview(save) {
    let finalDOMObj = {};

    // Prefer current render props; fall back to refs if props are briefly empty.
    const latestAnimationObject =
      animationObject &&
      typeof animationObject === "object" &&
      !Array.isArray(animationObject)
        ? animationObject
        : animationObjRef?.current &&
            typeof animationObjRef.current === "object" &&
            !Array.isArray(animationObjRef.current)
          ? animationObjRef.current
          : {};
    const latestLayerCompData = Array.isArray(layerCompData)
      ? layerCompData
      : Array.isArray(tempLayer?.current)
        ? tempLayer.current
        : [];

    // Keep the shared ref aligned with what preview is about to serialize.
    if (animationObjRef) {
      animationObjRef.current = latestAnimationObject;
    }
    if (tempLayer) {
      tempLayer.current = latestLayerCompData;
    }

    animationFinalObj = [];
    let animationObjectNew = JSON.parse(
      JSON.stringify(latestAnimationObject || {})
    );
    ensureHitAreaAnimationEntries(animationObjectNew, latestLayerCompData);

    // Commented out: do not add a default keyframe at 0s.
    // Object.values(animationObjectNew).forEach((obj, index) => {
    //   if (obj?.animation?.length > 0 && obj?.animation[0]?.delay !== 0) {
    //     let tempObj = obj.animation[0];
    //     tempObj.delay = 0;
    //     tempObj.duration = tempObj.end;
    //     let firstObject = {
    //       ...tempObj,
    //       rotation: 0,
    //       rotationX: 0,
    //       rotationY: 0,
    //       left: 0,
    //       top: 0,
    //       width: tempObj.width,
    //       height: tempObj.height,
    //       transform: 1,
    //       delay: 0,
    //       duration: 0,
    //       ease: "NONE",
    //       end: 0,
    //       opacity: tempObj.hasOwnProperty("hidden") ? 0 : 1,
    //       skewAnimation: false,
    //       translateX: 0,
    //       translateY: 0,
    //     };
    //     obj.animation.splice(0, 0, firstObject);
    //     obj.animation[1] = tempObj;
    //   }
    // });

    Object.keys(animationObjectNew).forEach((obj) => {
      const layerAnim = animationObjectNew[obj];
      if (!Array.isArray(layerAnim?.animation)) return;

      layerAnim.animation.forEach((eachAnimation) => {
        const animationData = {
          api: "to",
          atoms: [obj],
          duration: eachAnimation.duration,
          op: {
            delay: eachAnimation.delay,
            opacity: eachAnimation.opacity,
            ease: eachAnimation.ease,
            rotation: eachAnimation.rotation,
            rotationX: eachAnimation.rotationX,
            rotationY: eachAnimation.rotationY,
            scale: eachAnimation.transform,
            left: 0,
            top: 0,
            transform: `translate(${(eachAnimation.x || 0) + (eachAnimation.translateX || 0)}px,${(eachAnimation.y || 0) + (eachAnimation.translateY || 0)}px)`,
            width: eachAnimation.width,
            height: eachAnimation.height,
            transformOrigin: `${eachAnimation.transformOriginX}% ${eachAnimation.transformOriginY}% ${eachAnimation.transformOriginZ}px`,
            backgroundSize: `${eachAnimation.width}px ${eachAnimation.height}px`,
          },
        };
        animationFinalObj.push(animationData);
      });
    });

    finalDOMObj = downLoad({
      layerCompData: latestLayerCompData,
      assetId: appData.assetInfo.assetId,
      canvasDimension: canvasDimension,
      bgColorCanvas: bgColorCanvas,
      animationObject: animationObjectNew,
      flag: true,
      popUpOptions: popUpOptions,
      toggleAnimatedBanner: toggleAnimatedBanner,
    });
    let exportOptions = {
      backupFallback: backupFallback,
      animationObjectForSync: animationObjectNew,
    };
    let DOMObj = formDOMObj(finalDOMObj, undefined, exportOptions);
    let PreviewDOM = {
      html: DOMObj.html,
      fileName: appData.assetInfo.assetName,
    };
    if (save === "save") {
      return DOMObj;
    }

    const requestId = ++previewRequestIdRef.current;
    fileSizeValidation(DOMObj, async (response, err, errorCode) => {
      if (requestId !== previewRequestIdRef.current) return;
      if (err) {
        if (
          err.response?.data?.errorCode === "ERR_EXCEED_MAX_UPLOAD_SIZE_200KB"
        )
          // File Size Exceed More than 200 KB
          // toast.error(
          //   <div className="notificationText">
          //     {t("Warning - Banner size exceeds 200 KB!")}
          //   </div>,
          // );
          setLoading(false);
      } else {
      }
      preview(PreviewDOM, (response, err, errorCode) => {
        // Ignore outdated preview responses from earlier clicks.
        if (requestId !== previewRequestIdRef.current) return;
        if (err) {
          const errCoponent = ErrComponentToRender(errorCode);
        } else {
          if (response.data) {
            setpreviewURl(response.data);
            setPreView(true);
          }
        }
      });
    });
  }
  let enableUndo = false;
  let heilightUndo = false;

  if (addedActionsList[0]?.layerCompData.length)
    enableUndo = !refreshed
      ? addedActionsList.length && addedActionsList[0].layerCompData.length
      : addedActionsList.length > 1;

  const [openPublishDropdown, setOpenPublishDropdown] = React.useState(null);
  let open = Boolean(openPublishDropdown);

  const handleClose = () => {
    setOpenPublishDropdown(null);
  };

  const handleVeevaIntegration = async (e, type, obj) => {
    handleClose();
    setLoading(true);
    const formDatatype = new FormData();
    let htmlObj = {};

    if (type === "pdf") {
      handlefunctionality(e, "backIcon");

      let finalPdf = downLoadPdf(
        layerCompData,
        appData.assetInfo.assetId,
        canvasDimension,
        bgColorCanvas,
        {},
      );
      let DOMObj = formDOMObj(finalPdf);

      imageConversionBaseURL(
        "pdf",
        { html: DOMObj.html },
        (response, err, errorCode) => {
          if (err) {
            const errCoponent = ErrComponentToRender(errorCode);
            toast.error(errCoponent);
          } else {
            if (response?.status === 200) {
              var blob = new Blob([response?.data], {
                type: "application/pdf",
              });

              var file = new File(
                [blob],
                `${appData.assetInfo.assetName.trim()}.pdf`,
                {
                  type: "application/pdf",
                },
              );
              formDatatype.append("pdfFile", file);
              formDatatype.append("fileName", appData.assetInfo.assetName);
              formDatatype.append("fileType", "Pdf");
              formDatatype.append(
                "assetType",
                appData.banner ? "Banner" : "Template",
              );
            } else {
              setLoading(false);
              toast.error(
                <div className="notificationText">
                  Failed to download the PDF file
                </div>,
              );
              return;
            }
          }
        },
      );
    } else if (type === "html") {
      htmlObj = {
        fileType: "Html",
        html: obj.html,
        htmlFileName: obj.fileName,
        images: obj.img,
      };
    }
    veevaIntegration(
      type === "pdf" ? formDatatype : htmlObj,
      type,
      appData.assetInfo.assetId,
      (response, err, errorCode) => {
        if (err) {
          setLoading(false);
          toast.error(
            <div className="parentContainer">
              <img
                src={VeevaErrorIcon}
                className="approveIcon"
                alt="Error Icon"
              />
              <div className="pb-1 messageContainer">
                <div className="toastHeading">
                  {t(`DAMS Submission Unsuccessful`)}
                </div>
                <div className="row pleaseTryAgainVeeva">
                  {"Please try again"}
                </div>
              </div>
              <img src={ClearIcon} alt="" className="approveIcon" />
            </div>,
            {
              hideProgressBar: false,
              className: "toastMessageError",
              position: "top-right",
              transition: Slide,
              autoClose: 2000,
            },
          );
        } else {
          setLoading(false);
          let time = response.data.submittedOn.split(" ")[1].substring(0, 5);
          let name = localStorage.getItem("currentUserName");
          const date = new Date();

          toast.success(
            <div className="parentContainer">
              <img
                src={ApproveIcon}
                className="approveIcon"
                alt="Approve Icon"
              />
              <div className="pb-1 messageContainer">
                <div className="toastHeading">
                  {t(`DAMS Submission Successful`)}
                </div>
                <div
                  className={`fileType ${
                    response.data.fileType === "Html" ? "widthExtra" : ""
                  }`}
                >
                  <div className="veevaSuccessLHS">File type</div>
                  <div
                    className={` typeImageAndTag ${
                      response.data.fileType === "Html" ? "addWidth" : ""
                    }`}
                  >
                    <img
                      src={
                        response.data.fileType === "Pdf" ? PDFImage : HtmlImage
                      }
                      className="imageSize"
                      alt="PDFImage"
                    />
                    <span className="HTMLText">
                      {response.data.fileType === "Pdf" ? "PDF" : "HTML"}
                    </span>
                  </div>
                </div>
                <div className="row notificationText1">
                  <div className="col-md-4 veevaSuccessLHS">Veeva ID</div>
                  <div className="col-md-8 veevaSuccessRHS ">
                    {" "}
                    {response.data.veevaDocNumber}
                  </div>
                </div>
                <div className="row notificationText1">
                  <div className="col-md-4 veevaSuccessLHS">Submitted by</div>
                  <div className="col-md-8 veevaSuccessRHS"> {name}</div>
                </div>
                <div className="row notificationText1">
                  <div className="col-md-4 veevaSuccessLHS">Submitted on</div>
                  <div className="col-md-8 veevaSuccessRHS">
                    {" "}
                    {amPmConverter(response.data.submittedOn)}
                  </div>
                </div>
              </div>
              <img src={ClearIcon} alt="" className="approveIcon" />
            </div>,
            {
              hideProgressBar: false,
              className: "toastMessage",
              position: "top-right",
              autoClose: 2000,
              transition: Slide,
            },
          );
          setDamsId(response.data?.veevaDocNumber);
          setMLRstatus(response?.data?.reviewStatus);
        }
      },
    );
  };

  const handleVeevaIntegrationHtmlPublish = async (e, type, obj) => {
    handleClose();
    setLoading(true);
    let htmlObj = {};
    htmlObj = {
      fileType: "Html",
      html: obj.html,
      htmlFileName: obj.fileName,
      images: obj.img,
      assetType: appData.banner ? "Banner" : "Template",
    };
    veevaIntegrationHtmlPublish(
      htmlObj,
      appData.assetInfo.assetId,
      (response, err, errorCode) => {
        if (err) {
          setLoading(false);
          toast.error(
            <div className="parentContainer">
              <img
                src={VeevaErrorIcon}
                className="approveIcon"
                alt="Error Icon"
              />
              <div className="pb-1 messageContainer">
                <div className="toastHeading">
                  {t(`DAMS Submission Unsuccessful`)}
                </div>
                <div className="row pleaseTryAgainVeeva">
                  {"Please try again"}
                </div>
              </div>
              <img src={ClearIcon} alt="" className="approveIcon" />
            </div>,
            {
              hideProgressBar: false,
              className: "toastMessageError",
              position: "top-right",
              transition: Slide,
              autoClose: 2000,
            },
          );
        } else {
          setLoading(false);
          let time = response.data.submittedOn.split(" ")[1].substring(0, 5);
          let name = localStorage.getItem("currentUserName");
          const date = new Date();

          toast.success(
            <div className="parentContainer">
              <img
                src={ApproveIcon}
                className="approveIcon"
                alt="Approve Icon"
              />
              <div className="pb-1 messageContainer">
                <div className="toastHeading">
                  {t(`DAMS Submission Successful`)}
                </div>
                <div
                  className={`fileType ${
                    response.data.fileType === "Html" ? "widthExtra" : ""
                  }`}
                >
                  <div className="veevaSuccessLHS">File type</div>
                  <div
                    className={` typeImageAndTag ${
                      response.data.fileType === "Html" ? "addWidth" : ""
                    }`}
                  >
                    <img
                      src={
                        response.data.fileType === "Pdf" ? PDFImage : HtmlImage
                      }
                      className="imageSize"
                      alt="PDFImage"
                    />
                    <span className="HTMLText">
                      {response.data.fileType === "Pdf" ? "PDF" : "HTML"}
                    </span>
                  </div>
                </div>
                <div className="row notificationText1">
                  <div className="col-md-4 veevaSuccessLHS">Veeva ID</div>
                  <div className="col-md-8 veevaSuccessRHS ">
                    {" "}
                    {response.data.veevaDocNumber}
                  </div>
                </div>
                <div className="row notificationText1">
                  <div className="col-md-4 veevaSuccessLHS">Submitted by</div>
                  <div className="col-md-8 veevaSuccessRHS"> {name}</div>
                </div>
                <div className="row notificationText1">
                  <div className="col-md-4 veevaSuccessLHS">Submitted on</div>
                  <div className="col-md-8 veevaSuccessRHS">
                    {" "}
                    {amPmConverter(response.data.submittedOn)}
                  </div>
                </div>
              </div>
              <img src={ClearIcon} alt="" className="approveIcon" />
            </div>,
            {
              hideProgressBar: false,
              className: "toastMessage",
              position: "top-right",
              autoClose: 2000,
              transition: Slide,
            },
          );
          setDamsId(response.data?.veevaDocNumber);
          setMLRstatus(response?.data?.reviewStatus);
        }
      },
    );
  };
  const history = useHistory();
  const publishHTML = (e) => {
    animationFinalObj = [];
    let animationObjectNew = JSON.parse(JSON.stringify(animationObject || []));
    // Commented out: do not add a default keyframe at 0s.
    // Object.values(animationObjectNew).forEach((obj) => {
    //   if (obj?.animation.length > 0 && obj.animation[0].delay !== 0) {
    //     let tempObj = obj.animation[0];
    //     tempObj.delay = 0;
    //     tempObj.duration = tempObj.end;
    //     let firstObject = {
    //       ...tempObj,
    //       rotation: 0,
    //       rotationX: 0,
    //       rotationY: 0,
    //       left: 0,
    //       top: 0,
    //       width: tempObj.width,
    //       height: tempObj.height,
    //       transform: 1,
    //       delay: 0,
    //       duration: 0,
    //       ease: "NONE",
    //       end: 0,
    //       opacity: 1,
    //       translateX: 0,
    //       translateY: 0,
    //     };
    //     obj.animation.splice(0, 0, firstObject);
    //     obj.animation[1] = tempObj;
    //   }
    // });

    Object.keys(animationObjectNew).forEach((obj) => {
      animationObjectNew[obj].animation.forEach((eachAnimation) => {
        const animationData = {
          api: "to",
          atoms: [obj],
          duration: eachAnimation.duration,
          op: {
            delay: eachAnimation.delay,
            opacity: eachAnimation.opacity,
            ease: eachAnimation.ease,
            rotation: eachAnimation.rotation,
            rotationX: eachAnimation.rotationX,
            rotationY: eachAnimation.rotationY,
            scale: eachAnimation.transform,
            left: 0,
            top: 0,
            transform: `translate(${(eachAnimation.x || 0) + (eachAnimation.translateX || 0)}px,${(eachAnimation.y || 0) + (eachAnimation.translateY || 0)}px)`,
            width: eachAnimation.width,
            height: eachAnimation.height,
            transformOrigin: `${eachAnimation.transformOriginX}% ${eachAnimation.transformOriginY}% ${eachAnimation.transformOriginZ}px`,
            backgroundSize: `${eachAnimation.width}px ${eachAnimation.height}px`,
          },
        };
        animationFinalObj.push(animationData);
      });
    });
    let finalDOMObj = downLoad({
      layerCompData: layerCompData,
      assetId: appData.assetInfo.assetId,
      canvasDimension: canvasDimension,
      bgColorCanvas: bgColorCanvas,
      animationObject: checkExportType.PDF ? {} : animationObjectNew,
      flag:
        checkExportType.PNG === true || checkExportType?.JPEG === true
          ? true
          : false,
      popUpOptions: popUpOptions,
      toggleAnimatedBanner: toggleAnimatedBanner,
    });
    let DOMObjHTML = formDOMObj(finalDOMObj);
    fileSizeValidation(DOMObjHTML, async (response, err, errorCode) => {
      if (err) {
        if (
          err.response?.data?.errorCode === "ERR_EXCEED_MAX_UPLOAD_SIZE_200KB"
        )
          // File Size Exceed More than 200 KB
          toast.error(
            <div className="notificationText">
              {t("Warning - Banner size exceeds 200 KB!")}
            </div>,
          );
      }
    });
    handleVeevaIntegrationHtmlPublish(e, "html", DOMObjHTML);
  };

  const openInfoDialog = () => {
    setLoading(true);
    getbannerandTemplateDetails(
      appData.assetInfo.assetId,
      async (response, err, errorCode) => {
        if (err) {
          toast.error(
            <div className="notificationText">
              {t("Failed to fetch the details.!")}
            </div>,
          );
          setLoading(false);
        } else {
          const normalizedDetails = response?.data || response || {};
          setLoading(false);
          setBannerTemplateDetails(normalizedDetails);
          setOpenInfoDetails(true);
        }
      },
    );
  };
  const handleUserActionChange = (option) => {
    const selectedOption =
      typeof option === "string" ? option : option?.value || option?.label || "";

    if (selectedOption === "Run Validations Check") {
      if (data.length === 0) {
        toast.success(
          <div className="notificationText">Validation Successful.</div>,
        );
      } else {
        setRunValidationCheckEnabled(true);
      }
    } else if (selectedOption === "Export") {
      handlefunctionality({ target: { name: "export" } }, "change");
    } else if (selectedOption === "Details") {
      openInfoDialog();
    } else if (selectedOption === "Backup Image Settings") {
      const currentAssetId = appData?.assetInfo?.assetId || bannerId;
      history.push({
        pathname: `/backup-image-settings/${currentAssetId}`,
        state: { baseBannerId: currentAssetId },
      });
    }
  };

  const hasEditorContent =
    Array.isArray(layerCompData) &&
    layerCompData.some((layer) => {
      if (!layer || typeof layer !== "object") return false;

      const componentType = layer?.componentType;
      const supportedTypes = ["Text", "Button", "Image", "Shape", "Scrollbar"];
      if (!supportedTypes.includes(componentType)) return false;

      // Exclude legacy non-content text blocks from content gating.
      const addContent = layer?.textComponentType?.addContent;
      if (
        componentType === "Text" &&
        ["Reference", "Footnotes", "Abbreviation"].includes(addContent)
      ) {
        return false;
      }

      if (!layer?.componentStyles) return false;

      // Ignore auto-inserted full-canvas white base rectangle for OTC gating.
      if (componentType === "Shape" && addContent === "rectangleShape") {
        const left = Number(layer?.componentStyles?.left);
        const top = Number(layer?.componentStyles?.top);
        const width = Number(layer?.componentStyles?.width);
        const height = Number(layer?.componentStyles?.height);
        const canvasWidth = Number(canvasDimension?.width);
        const canvasHeight = Number(canvasDimension?.height);
        const isCanvasSized =
          Number.isFinite(width) &&
          Number.isFinite(height) &&
          Math.abs(width - canvasWidth) <= 1 &&
          Math.abs(height - canvasHeight) <= 1;
        const bg = layer?.componentStyles?.backgroundColor;
        const isWhiteBg =
          (typeof bg === "string" &&
            (bg.toLowerCase().includes("255,255,255") ||
              bg.toLowerCase() === "#ffffff")) ||
          (typeof bg === "object" &&
            Number(bg?.r) === 255 &&
            Number(bg?.g) === 255 &&
            Number(bg?.b) === 255);
        if (left === 0 && top === 0 && isCanvasSized && isWhiteBg) {
          return false;
        }
      }

      // Image should have a source payload once dropped on canvas.
      if (componentType === "Image") {
        return Boolean(
          layer?.componentStyles?.background ||
          layer?.componentStyles?.imgUrl ||
          layer?.componentStyles?.filename,
        );
      }

      return true;
    });
  // const isOtcBannerWithoutContent = isOneTimeAsset && !hasEditorContent;
  // const generateRsdTooltipMessage = isOtcBannerWithoutContent
  //   ? "At least one element/component must be present inside the editor to proceed with RSD generation."
  //   : !isOneTimeAsset && data.length !== 0
  //     ? "Please use all the must use module elements. To know more click on Run Validation Check option under User Actions cta."
  //     : "";
  const isOtcBannerWithoutContent = !hasEditorContent;
  const generateRsdTooltipMessage = isOtcBannerWithoutContent
    ? "At least one element/component must be present inside the editor to proceed with RSD generation."
    : "";
  // const isGenerateRsdDisabled = isOneTimeAsset
  //   ? !hasEditorContent
  //   : data.length !== 0 || !bannerValidationCheck;
  const isGenerateRsdDisabled = layerCompData?.length === 0;

  const handleMouseEnterGenerateRsd = () => {
    if (isGenerateRsdDisabled && generateRsdTooltipMessage) {
      setContextMenuGenerateRsd(true);
      return;
    }
    setContextMenuGenerateRsd(false);
  };
  const handleMouseLeaveGenerateRsd = () => {
    setContextMenuGenerateRsd(false);
  };
  const handleGenerateRsdClick = (event) => {
    // if (isGenerateRsdDisabled) {
    //   event.preventDefault();
    //   event.stopPropagation();
    //   return;
    // }
    handleGenerateRSD();
  };

  const currentSizeLabel =
    selectedSizeOptions?.find(
      (opt) => opt.value === (selectedSizes || selectedBannerSize),
    )?.label || "";
  const safeAssetType =
    showAssettype || (appData.banner ? "Banner" : "Template");
  const safeBannerType =
    typeof showBannertype === "string" ? showBannertype.trim() : "";
  const editorHeaderLabel = safeBannerType
    ? `${safeAssetType} Editor | ${safeBannerType}`
    : `${safeAssetType} Editor`;
  const bannerNameText =
    typeof showBannerName === "string" ? showBannerName.trim() : "";
  const hasBannerName = bannerNameText.length > 0;

  return (
    <>
      <div
        className="container-fluid editorTempheader"
        style={{ pointerEvents: !playPause.animationCompleted && "none" }}
      >
        <div className="row editHeader">
          <div className="col-md-3 d-flex tempHeaderLeft">
            <div className="contstud-title">
              <div className=" d-flex editorHeading">
                <div className=" d-flex editorTempHeading">
                  <img
                    src={homebtn}
                    alt=""
                    className="backIcon"
                    onClick={(e) => {
                      if (
                        !nameValidation(
                          appData.assetInfo.assetName,
                          showAssettype,
                        )
                      )
                        return;
                      handlefunctionality(e, "backIcon");
                      appData.setBanner(
                        showAssettype === "Banner" ? true : false,
                      );
                      window.location.href = "/";
                      window.localStorage.removeItem("oneTimeAsset");
                      setIsOneTimeAsset(false);
                    }}
                  />
                  <div className="vertical-line"></div>
                  <p className="templateheading">{editorHeaderLabel}</p>

                  <br />
                  {safeAssetType === "Template"
                    ? hasBannerName && (
                        <div
                          className={
                            showBannertype === "Animated"
                              ? "tempName"
                              : "tempNamebanner"
                          }
                        >
                          <Tooltip title={bannerNameText}>
                            <h6 className="editorTemp-name">
                              {bannerNameText}
                            </h6>
                          </Tooltip>
                        </div>
                      )
                    : hasBannerName && (
                        <div
                          style={
                            showBannertype === "Animated"
                              ? { right: "135px" }
                              : { right: "113px" }
                          }
                          className={
                            showBannertype === "Animated"
                              ? "bnrNameAnimated"
                              : "bannername"
                          }
                        >
                          <div className="editor-name-tag-wrap">
                            {hasBannerName && (
                              <Tooltip title={bannerNameText}>
                                <h6 className="editorTemp-name">
                                  {bannerNameText}
                                </h6>
                              </Tooltip>
                            )}
                            {/* {isOneTimeAsset && (
                              <span className="otc-tag-badge">OTC</span>
                            )} */}
                          </div>
                        </div>
                      )}
                </div>
              </div>
            </div>
          </div>

          <div
            className="col-md-2 editorHeaderTempRight"
            style={{ display: "flex" }}
          >
            <div
              className="align-items-center  editorNavIcons"
              style={{ marginLeft: "-26px" }}
            >
              <ul className="d-flex  mb-0 headerLeftdata">
                <li className="editorList">
                  <div
                    className="img-with-text d-flex "
                    style={{ marginTop: "11px" }}
                  >
                    <div className="headerIconBlock">
                      <Tooltip title="Save changes">
                        <img
                          id="saveImage"
                          src={SaveIcon}
                          alt=""
                          name="save"
                          className="img-fluid"
                          onClick={(e) => handlefunctionality(e)}
                        />
                      </Tooltip>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div className="editorList">
              <div
                className="img-with-text d-flex "
                style={{ marginTop: "14px" }}
              >
                <div
                  className="headerIconBlock"
                  style={{ cursor: undoVersion <= 1 ? "default" : "pointer" }}
                >
                  <Tooltip title={undoVersion <= 1 ? "" : "Undo"}>
                    <img
                      id="undoChanges"
                      src={undoVersion <= 1 ? UndoIconDisbaled : UndoIcon}
                      alt=""
                      name="undo"
                      className="img-fluid"
                      onClick={
                        undoVersion <= 1 ? () => {} : (e) => handleUndo(e)
                      }
                    />
                  </Tooltip>
                </div>
              </div>
            </div>
            <div className="editorList">
              <div
                className="img-with-text d-flex "
                style={{ marginTop: "14px" }}
              >
                <div
                  className="headerIconBlock"
                  style={{
                    cursor:
                      redoStack.current.length === 0 ? "default" : "pointer",
                  }}
                >
                  <Tooltip title={redoStack.current.length === 0 ? "" : "Redo"}>
                    <img
                      id="redoChanges"
                      src={
                        redoStack.current.length === 0
                          ? RedoIconDisabled
                          : RedoIcon
                      }
                      alt=""
                      name="redo"
                      className="img-fluid"
                      onClick={
                        redoStack.current.length === 0
                          ? () => {}
                          : (e) => handleRedo(e)
                      }
                    />
                  </Tooltip>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3"></div>
          <div className="col-md-3 editorTempheaderRight">
            <div
              className="d-flex align-items-center justify-content-end  editorNavIcons"
              style={{ marginRight: 30 }}
            >
              <ul className="d-flex mb-0 undoicon">
                <li style={{ paddingTop: "12px" }}>
                  <EditorSelect
                    label="Select an option"
                    options={selectedSizeOptions}
                    value={selectedSizes ? selectedSizes : selectedBannerSize}
                    onChange={handleBannerSizeChange}
                    disabled={false}
                  />
                </li>
                <div
                  className="vertical-line2"
                  style={{ marginRight: "10px", marginLeft: "16px" }}
                ></div>
                <li className="linkBorderzoom">
                  <div className="zoomDiv">
                    <div className="d-flex zoomInOut">
                      <div className="zoomOut" onClick={handleZoomOut}>
                        <Tooltip title="Zoom (-)">
                          <RemoveIcon />
                        </Tooltip>
                      </div>

                      <div className="zoomPercentage">
                        {canvasDimension.zoomValue}%
                      </div>
                      <div className="zoomIn" onClick={handleZoomIn}>
                        <Tooltip title="Zoom (+)">
                          <AddIcon />
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                </li>
                <div className="vertical-line2"></div>
                <li>
                  <ul className="rightTopThreeIcons">
                    <li>
                      <div
                        className="img-with-text text-center editorRightImage preicon"
                        onClick={() => handlePreview()}
                      >
                        <div className="headerIconBlock2 ">
                          <Tooltip title="Preview">
                            <img
                              src={PreviewIcon}
                              alt=""
                              className="img-fluid mb-0 previewIcon"
                            ></img>
                          </Tooltip>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div
                        className="useractiondrop"
                        style={{
                          marginRight: "-145px",
                          marginTop: "4px",
                          marginLeft: "12px",
                        }}
                      >
                        <TemplateTypeDropDown
                          title={"USER ACTIONS"}
                          data={userActionsType}
                          handleChange={handleUserActionChange}
                          borderNotDisabled={true}
                        />
                      </div>
                    </li>

                    <li>
                      <div>
                        <Button
                          id="basic-button"
                          aria-controls={open ? "basic-menu" : undefined}
                          aria-haspopup="true"
                          aria-expanded={open ? "true" : undefined}
                          //aria-disabled={isGenerateRsdDisabled}
                          type="button"
                          // className={`publishvvpmBtn editorRightImage`}
                          // className={`publishvvpmBtn editorRightImage ${
                          //   isGenerateRsdDisabled ? "disabled-button" : ""
                          // }`}
                          className={`publishvvpmBtn editorRightImage `}
                          onClick={handleGenerateRsdClick}
                          // onMouseEnter={handleMouseEnterGenerateRsd}
                          //onMouseLeave={handleMouseLeaveGenerateRsd}
                        >
                          {appData.banner ? t("GENERATE RSD") : t("PUBLISH")}
                        </Button>
                        {/* {contextMenuGenerateRsd &&
                          generateRsdTooltipMessage && (
                            <>
                              <div className="contextMenuRunValidation d-flex">
                                {generateRsdTooltipMessage}
                              </div>
                              <div
                                class="contextMenuarrowRCRunValidation"
                                id="contextMenuarrowRCRunValidation"
                              ></div>
                            </>
                          )} */}
                      </div>

                      <Menu
                        id="basic-menu"
                        MenuListProps={{
                          "aria-labelledby": "basic-button",
                        }}
                        anchorEl={openPublishDropdown}
                        open={open}
                        onClose={handleClose}
                        className="dropdownPublish"
                        PaperProps={{
                          style: {
                            position: "absolute",
                            width: "180px",
                            height: "auto",

                            borderRadius: "4px",
                            boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.16)",
                            backgroundColor: "#fff",
                          },
                        }}
                      >
                        <MenuItem
                          disabled={!pdfHtmlEnabled.pdfEnabled}
                          onClick={(e) => handleVeevaIntegration(e, "pdf", {})}
                          className={pdfHtmlEnabled.pdfEnabled && "enable"}
                        >
                          {t("PDF")}
                        </MenuItem>
                        {!pdfHtmlEnabled.pdfEnabled && (
                          <div className="d-flex htmlInfo">
                            <img
                              src={InfoIcon}
                              alt=""
                              className="img-fluid htmlinfoIcon"
                            />
                            {t(`Publish disable for approved ${showAssettype}`)}
                          </div>
                        )}
                        <MenuItem
                          disabled={!pdfHtmlEnabled.htmlEnabled}
                          className={pdfHtmlEnabled.htmlEnabled && "enable"}
                          onClick={(e) => publishHTML(e)}
                        >
                          {t("HTML")}
                        </MenuItem>
                        {""}
                        <MenuItem disabled>{t("Google Click Studio")}</MenuItem>
                      </Menu>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {runValidationCheckEnabled && (
          <RunValidationCheckModal
            showBannerName={showBannerName}
            mustUseData={mustUseData}
            data={data}
            setRunValidationCheckEnabled={setRunValidationCheckEnabled}
          />
        )}
        {openInfoDetails && (
          <InfoDetailsDialog
            setOpenInfoDetails={setOpenInfoDetails}
            showAssettype={showAssettype}
            toggleAnimatedBanner={toggleAnimatedBanner}
            bannerTemplateDetails={bannerTemplateDetails}
            setLoading={setLoading}
            loading={loading}
            patchCall={patchCall}
            setShowBannerName={setShowBannerName}
            currentSize={currentSizeLabel}
          />
        )}
        {showExport && (
          <ExportModal
            showBasedOn={showExport}
            setLoading={setLoading}
            setExport={setExport}
            exportType={exportType}
            checkExportType={checkExportType}
            setCheckExportType={setCheckExportType}
            rvcvTypes={rvcvTypes}
            setRvcvTypes={setRvcvTypes}
            toggleAnimatedBanner={toggleAnimatedBanner}
          />
        )}
        {loading && (
          <>
            <div className="modal-backdrop fade show"> </div>
            <CircularProgress size="30px" className="customLoader" />{" "}
          </>
        )}
        {showPreview && (
          <PreviewModal
            assetId={appData?.assetInfo?.assetId}
            previewURl={previewURl}
            previewAssetData={layerCompData}
            setPreview={setPreView}
            showPreview={showPreview}
            setLoading={setLoading}
            redirectOnClose={previewRedirectHome}
            showBackupImageTab
          />
        )}
      </div>
      {
        <BannerEditorConfirmation
          showConfirmation={showConfirmation}
          handleCancel={handleCancel}
          handleProceed={handleProceed}
        />
      }
    </>
  );
}
